"use client";
import { useMemo } from "react";

import {
  guessLogoWithAirlineName,
  useFlightStaticData,
} from "../../../core/flight-static-data";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import ProductBarChart from "../ProductBarChart/ProductBarChart";
import { ProductBarChartTransaction } from "../ProductBarChart/types";
import { ViewType } from "../types";
import { Top5AirlinesTransactionsResult } from "./types";

type Props = {
  data: Top5AirlinesTransactionsResult;
  viewType?: ViewType;
  interactive?: boolean;
};

export default function TopAirlinesBarChart({
  data,
  viewType,
  interactive,
}: Props) {
  const { CorporateTransactionDataAnalytics: cr } = useMobileContentResource();
  const { data: staticData } = useFlightStaticData();

  const transactions: ProductBarChartTransaction[] = useMemo(
    () =>
      data.top5AirlinesTransactions.transactions.map((t) => ({
        month: t.month,
        year: t.year,
        quarter: t.quarter,
        sortDate: t.truncatedDate,
        entries: t.airlines.map((a) => ({
          name: a.airlineName,
          value: a.amount,
          logoUrl: guessLogoWithAirlineName(a.airlineName, staticData),
        })),
      })),
    [data, staticData]
  );

  return (
    <ProductBarChart
      note={cr.inBillions}
      transactions={transactions}
      viewType={viewType}
      interactive={interactive}
    />
  );
}
